import { c as _c } from "react/compiler-runtime";
import { Box, Flex, Text } from "@chakra-ui/react";
import { formatTime } from "./timePickerUtils";
interface TickMarkersProps {
  hourMarkers: number[];
  minutesToTrackPercent: (minutes: number) => number;
}
export const TickLabels = t0 => {
  const $ = _c(7);
  const {
    hourMarkers,
    minutesToTrackPercent
  } = t0;
  let t1;
  if ($[0] !== hourMarkers || $[1] !== minutesToTrackPercent) {
    let t2;
    if ($[3] !== minutesToTrackPercent) {
      t2 = marker => <Text key={marker} position="absolute" left={`${minutesToTrackPercent(marker)}%`} transform="translateX(-50%)" fontSize="xs" color="text" whiteSpace="nowrap">{formatTime(marker)}</Text>;
      $[3] = minutesToTrackPercent;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = hourMarkers.map(t2);
    $[0] = hourMarkers;
    $[1] = minutesToTrackPercent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <Flex position="relative" height="5" mb="3">{t1}</Flex>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const TickLines = t0 => {
  const $ = _c(8);
  const {
    hourMarkers,
    minutesToTrackPercent
  } = t0;
  let t1;
  if ($[0] !== hourMarkers || $[1] !== minutesToTrackPercent) {
    let t2;
    if ($[3] !== minutesToTrackPercent) {
      t2 = marker => <Box key={`tick-${marker}`} position="absolute" left={`${minutesToTrackPercent(marker)}%`} top="-0.5rem" bottom="-0.5rem" borderLeft="1px dotted" borderColor="grey.400" zIndex={0} pointerEvents="none" />;
      $[3] = minutesToTrackPercent;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = hourMarkers.map(t2);
    $[0] = hourMarkers;
    $[1] = minutesToTrackPercent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box position="absolute" left="0" right="0" bottom="-0.5rem" height="1px" bg="white" zIndex={0} pointerEvents="none" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};